// Main TypeScript entry point

import Player from './player';

function setupBurger() {
  const burger = document.querySelector('.navbar-burger') as HTMLElement;
  if (burger) {
    burger.onclick = function() {
      const targetName = burger.dataset.target;
      if (targetName) {
        const target = document.getElementById(targetName);
        burger.classList.toggle('is-active');
        target?.classList.toggle('is-active');
      }
    };
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Initialize mobile menu
  setupBurger();

  // Initialize audio players for elements with data-sound-url attribute
  const playerElements = document.querySelectorAll<HTMLElement>('[data-sound-url]');
  playerElements.forEach(element => {
    new Player(element);
  });
});
